<template>
    <v-card-actions
        id="step-footer"
        class="pa-0"
    >
        <v-container class="pa-0">
            <div
                id='step-footer-previous-btn'
                class="d-flex justify-start pt-2"
                v-if="showBackButton"
            >
                <v-btn
                    text
                    plain
                    class='text-none dark-text habiteo-body-2'
                    @click.prevent="previousStep()"
                >
                    <v-icon>
                        mdi-arrow-left
                    </v-icon>
                    <span class="text-decoration-underline">
                        {{ $t('utils.previous') }}
                    </span>
                </v-btn>
            </div>
            <v-divider/>
            <div
                class="d-flex align-stretch px-6 py-4"
                :class="{
                    'justify-end': currentStep === 1,
                    'justify-center': currentStep > 1
                }"
            >
                <template v-if="isDownloadStep">
                    <v-btn
                        v-if="false"
                        class="dark-text text-none text-decoration-underline habiteo-body-1 pa-4"
                        :elevation="0"
                        x-large
                        :width="100"
                        color="transparent"
                        :ripple="false"
                    >
                        {{ $t('habiteoStudio.exportHistory') }}
                    </v-btn>

                    <v-btn
                        color="green darken-1"
                        class="white--text text-none habiteo-body-1 pa-4"
                        :elevation="0"
                        x-large
                        :width="200"
                        :ripple="false"
                        @click.stop="resetForm"
                    >
                        {{ $t('habiteoStudio.newExport') }}
                    </v-btn>
                </template>
                <template v-else-if="isDownloading || isImporting">
                    <v-btn
                        class="dark-text text-none text-decoration-underline habiteo-body-1"
                        :elevation="0"
                        large
                        block
                        color="transparent"
                        :ripple="false"
                        @click.stop="cancelExport"
                    >
                        {{ $t('utils.cancel') }}
                    </v-btn>
                </template>
                <template v-else>
                    <v-btn
                        v-if="currentStep > 1 && step.id !== 'step_4'"
                        class="step-footer-btn green-text text-none habiteo-body-1 mx-5 pa-2"
                        :elevation="0"
                        :ripple="false"
                        @click.prevent="!isExportStep ? previousStep() : goBackSummary()"
                    >
                        {{ $t('utils.previous') }}
                    </v-btn>
                    <v-btn
                        v-if="step.id === 'step_4'"
                        class="step-footer-btn green-text text-none habiteo-body-1 mx-5 pa-2"
                        :elevation="0"
                        :ripple="false"
                        @click.prevent="startExport"
                    >
                        {{ $t('habiteoStudio.download') }}
                    </v-btn>
                    <v-btn
                        v-if="step.id !== 'step_4'"
                        color="green darken-2"
                        class="step-footer-btn text-none habiteo-body-1 pa-2 white--text mx-5"
                        :elevation="0"
                        @click.prevent="nextStep()"
                    >
                        {{ $t('utils.next') }}
                    </v-btn>
                    <v-btn
                        v-if="step.id === 'step_4'"
                        color="green darken-2"
                        class="step-footer-btn text-none habiteo-body-1 pa-2 white--text mx-5"
                        :elevation="0"
                        @click="startImport"
                    >
                        {{ $t('utils.import') }}
                    </v-btn>
                    
                </template>
            </div>
        </v-container>
    </v-card-actions>
</template>

<script>
    export default {
        name: 'StepFooter',
        props: {
            currentStep: {
                type: Number,
                required: true
            },
            isDownloading: {
                type: Boolean,
                required: true
            },
            isImporting: {
                type: Boolean,
                required: true
            },
            isExportStep: {
                type: Boolean,
                required: true
            },
            isDownloadStep: {
                type: Boolean,
                required: true
            },
            isEditingStep: {
                type: Boolean,
                required: true
            },
            maxStep: {
                type: Number,
                required: true
            },
            step: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                skippedFields: {'step_3': ['advanced_preset']}
            }
        },
        computed: {
            fieldsToFill() {
                let fields = {};
                if (this.$props.step) {
                    this.$props.step.forms.forEach(form => {
                        form.inputs.forEach(input => {
                            if(this.skippedFields[this.$props.step.id] && this.skippedFields[this.$props.step.id].includes(input.id)) {
                                return;
                            }
                            fields[input.id] = input.value;
                        })
                    });
                    return fields;
                } else
                    return null;
            },
            stepIsFilled() {
                let status = true;
                Object.keys(this.fieldsToFill).forEach(key => {
                    if (this.fieldsToFill[key] === null)
                        status = false;
                });
                return status;
            },
            showBackButton() {
                return this.$props.step.id === 'step_4' && !this.$props.isDownloadStep && !this.$props.isDownloading && !this.$props.isImporting;
            },
        },
        methods: {
            startExport() {
                this.$emit('start-export', true);
            },
            startImport() {
                this.$emit('start-export', false);
            },
            nextStep() {
                this.$emit('next-step');
            },
            previousStep() {
                this.$emit('previous-step');
            },
            cancelExport() {
                this.$emit('cancel-export');
            },
            resetForm() {
                this.$emit('reset-form');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/StepFooter.vue